(function ($, undefined) {

    const body = $('body');
    const windowWidth = body.innerWidth();
    const headOffset = $(window).height();


    //synchronize mobile menu close and contact scroll
    let mobileLink = $('.header-mobile-btns a.scroll');
    let mobileBtn = $('.header-mobile-btns button');

    mobileLink.on('click', function () {
        mobileBtn.trigger('click');
    });

    //smooth scroll
    $('a.scroll').click(function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 500);
        return false;
    });







    //highlight current page
    $(function () {
        // this will get the full URL at the address bar
        var url = window.location.href;
        url = url.replace(/\/#$/, '').replace('/#', '#').replace(/\/$/, '');
        var headerLink = $("#navbarHeader a");

        if (windowWidth < 991) {
            headerLink = $('.modal-menu a');
        }

        // passes on every "a" tag
        headerLink.each(function () {
            var targetUrl = this.href;
            // checks if its the same on the address bar
            if ((url == (targetUrl))) {
                $(this).addClass("active").parents('li').addClass('active');
            }
        });
    });




    function stickyFormatsNav() {

        if (($(window).scrollTop() >= sticky) && ($(window).scrollTop() < banner)) {
            formatsNav.addClass('sticky');
            $('#formatTab1').css('margin-top', '125px');
        } else {
            formatsNav.removeClass('sticky');
            $('#formatTab1').css('margin-top', '0');

        }
    }

    $(function() {
        // When the hamburger button is clicked, toggle the active class on the button and the menu
        $('#site-navigation button').on('click', function() {
            $(this).toggleClass('active');
            $('#site-navigation').toggleClass('active');
        });

        // When the close button is clicked, remove the active class from the hamburger button and the menu
        $('.close').on('click', function() {
            $('#site-navigation button').removeClass('active');
            $('#site-navigation').removeClass('active');
        });
    });



})(jQuery);